export const IMAGE_TAGS = {
  EVENT_IMAGE: "eventImage",
  EVENT_CROP_IMAGE: "eventCropImage",
  AADHAR_FRONT: "aadharFront",
  AADHAR_BACK: "aadharBack",
  USER_PROFILE: "userProfile",
  ORGANIZER_PROFILE: "organizerProfile",
  AADHAR: "aadhar",
  PAN_CARD:  "panCard",
  PAN_CARD_FRONT:  "panCardFront",
  PAN_CARD_BACK:  "panCardBack",
  PASSPORT:  "passport",
  PASSPORT_FRONT:  "passportFront",
  PASSPORT_BACK:  "passportBack",
  DRIVING_LICENSE:  "drivingLicense",
  DRIVING_LICENSE_FRONT:  "drivingLicenseFront",
  DRIVING_LICENSE_BACK:  "drivingLicenseBack",
  OTHERS:  "others",
  GST:  "gst",
}
